import React, { useEffect, useState } from "react";
import api from "../api/api";
import ParentsStudentGrades from "../pages/Students/ParentsStudentGrades";
import defaultAvatar from "./maleee.jpg";
import TransActionPerStudent from "../SchoolDashApp/DailyTransaction/TransActionPerStudent";

import {
Avatar,
Box,
Button,
Typography,
TextField,
Divider,
IconButton,
InputAdornment
} from "@mui/material";

import {
Search,
ArrowBack,
ArrowForward,
ArrowBackIosNew,
School,
AccountBalanceWallet,
EventAvailable,
ReportProblem,
ArrowBack as BackIcon
} from "@mui/icons-material";

const COLORS = {
black: "#111111",
darkBlack: "#1c1c1c",
orange: "#e87519",
deepOrange: "#bd4e00",
camel: "#c89b5b",
lightCamel: "#f4e4ce",
cream: "#fffaf3",
white: "#ffffff",
gray: "#6b7280",
lightGray: "#f5f5f5",
border: "rgba(17,17,17,0.10)",
green: "#2e7d32",
red: "#c62828",
blue: "#1565c0"
};

const formatCurrency = (value) => {
const number = parseFloat(value);


if (isNaN(number)) {
    return "$0.00";
}

return `$${number.toFixed(2)}`;


};

const LinkStudents = () => {
const [children, setChildren] = useState([]);
const [filteredChildren, setFilteredChildren] = useState([]);
const [selectedChild, setSelectedChild] = useState(null);
const [showGrades, setShowGrades] = useState(false);
const [showPayments, setShowPayments] = useState(false);
const [searchTerm, setSearchTerm] = useState("");
const [complaintIndices, setComplaintIndices] = useState({});


const token = localStorage.getItem("access");

useEffect(() => {
    const fetchLinkedStudents = async () => {
        try {
            if (!token) return;

            const res = await api.get(
                "/admissions/my-linked-students/",
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            setChildren(res.data);
            setFilteredChildren(res.data);
        } catch (error) {
            console.error(
                "Error fetching linked students:",
                error
            );
        }
    };

    fetchLinkedStudents();
}, [token]);

const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();

    setSearchTerm(value);

    const filtered = children.filter((child) =>
        child.full_name
            ?.toLowerCase()
            .includes(value)
    );

    setFilteredChildren(filtered);
};

const selectChild = (child) => {
    setSelectedChild(child);
    setShowGrades(false);
    setShowPayments(false);
};

const InfoRow = ({ label, value }) => (
    <Box
        sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 2,
            py: 1,
            borderBottom: `1px solid ${COLORS.border}`,
            "&:last-child": {
                borderBottom: "none"
            }
        }}
    >
        <Typography
            sx={{
                color: COLORS.gray,
                fontSize: {
                    xs: "0.75rem",
                    sm: "0.85rem"
                },
                fontWeight: 700
            }}
        >
            {label}
        </Typography>

        <Typography
            sx={{
                color: COLORS.black,
                fontSize: {
                    xs: "0.78rem",
                    sm: "0.88rem"
                },
                fontWeight: 800,
                textAlign: "right",
                wordBreak: "break-word"
            }}
        >
            {value || "N/A"}
        </Typography>
    </Box>
);

const SectionCard = ({
    title,
    icon,
    children,
    fullWidth = false
}) => (
    <Box
        sx={{
            flex: fullWidth
                ? "1 1 100%"
                : "1 1 300px",
            minWidth: {
                xs: "100%",
                sm: 280
            },
            p: {
                xs: 1.8,
                sm: 2.5,
                md: 3
            },
            borderRadius: {
                xs: "18px",
                md: "24px"
            },
            background:
                "linear-gradient(145deg, #ffffff 0%, #fff8ee 100%)",
            border: `1px solid ${COLORS.border}`,
            boxShadow:
                "0 10px 30px rgba(17,17,17,0.07)",
            display: "flex",
            flexDirection: "column",
            gap: 2
        }}
    >
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.2
            }}
        >
            <Box
                sx={{
                    width: 38,
                    height: 38,
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: COLORS.white,
                    background:
                        "linear-gradient(135deg, #111111, #e87519)",
                    flexShrink: 0
                }}
            >
                {icon}
            </Box>

            <Typography
                sx={{
                    fontWeight: 900,
                    color: COLORS.black,
                    fontSize: {
                        xs: "0.95rem",
                        sm: "1.05rem"
                    }
                }}
            >
                {title}
            </Typography>
        </Box>

        {children}
    </Box>
);

const StatGrid = ({ items }) => (
    <Box
        sx={{
            display: "grid",
            gridTemplateColumns: {
                xs: "repeat(2, minmax(0, 1fr))",
                sm: `repeat(${items.length}, minmax(0, 1fr))`
            },
            gap: {
                xs: 1,
                sm: 1.5
            }
        }}
    >
        {items.map(({ label, value, color }) => (
            <Box
                key={label}
                sx={{
                    p: {
                        xs: 1.2,
                        sm: 1.5
                    },
                    minHeight: {
                        xs: 82,
                        sm: 95
                    },
                    borderRadius: "15px",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    background: COLORS.white,
                    border: `1px solid ${COLORS.border}`,
                    transition:
                        "all 0.25s ease",
                    "&:hover": {
                        transform:
                            "translateY(-3px)",
                        boxShadow:
                            "0 8px 20px rgba(0,0,0,0.08)"
                    }
                }}
            >
                <Typography
                    sx={{
                        color: COLORS.gray,
                        fontSize: {
                            xs: "0.68rem",
                            sm: "0.75rem"
                        },
                        fontWeight: 700,
                        mb: 0.5
                    }}
                >
                    {label}
                </Typography>

                <Typography
                    sx={{
                        color: color || COLORS.black,
                        fontSize: {
                            xs: "0.9rem",
                            sm: "1.05rem"
                        },
                        fontWeight: 900,
                        wordBreak: "break-word"
                    }}
                >
                    {value}
                </Typography>
            </Box>
        ))}
    </Box>
);

const setChildComplaintIndex = (
    childId,
    newIndex
) => {
    setComplaintIndices((prev) => ({
        ...prev,
        [childId]: newIndex
    }));
};

const currentComplaintIndex = (child) =>
    complaintIndices[child.id] ?? 0;

const handlePrev = (child) => {
    const index =
        currentComplaintIndex(child);

    if (index > 0) {
        setChildComplaintIndex(
            child.id,
            index - 1
        );
    }
};

const handleNext = (child, total) => {
    const index =
        currentComplaintIndex(child);

    if (index < total - 1) {
        setChildComplaintIndex(
            child.id,
            index + 1
        );
    }
};

return (
    <Box
        sx={{
            width: "100%",
            minHeight: "100%",
            px: {
                xs: 0,
                sm: 1,
                md: 2
            },
            py: {
                xs: 1,
                sm: 2
            }
        }}
    >
        {!selectedChild ? (
            <>
                {/* CHILDREN LIST HEADER */}
                <Box
                    sx={{
                        textAlign: "center",
                        mb: 3
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 900,
                            color: COLORS.black,
                            fontSize: {
                                xs: "1.35rem",
                                sm: "1.7rem",
                                md: "2rem"
                            }
                        }}
                    >
                        My Children
                    </Typography>

                    <Typography
                        sx={{
                            mt: 0.7,
                            color: COLORS.gray,
                            fontSize: {
                                xs: "0.8rem",
                                sm: "0.9rem"
                            }
                        }}
                    >
                        Select a student to view academic
                        information and performance.
                    </Typography>
                </Box>

                {/* SEARCH */}
                <TextField
                    fullWidth
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Search student by name..."
                    size="small"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search
                                    sx={{
                                        color: COLORS.orange
                                    }}
                                />
                            </InputAdornment>
                        )
                    }}
                    sx={{
                        mb: 2.5,
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "15px",
                            backgroundColor:
                                COLORS.white,
                            "& fieldset": {
                                borderColor:
                                    COLORS.border
                            },
                            "&:hover fieldset": {
                                borderColor:
                                    COLORS.orange
                            },
                            "&.Mui-focused fieldset": {
                                borderColor:
                                    COLORS.orange
                            }
                        },
                        "& input": {
                            fontSize: {
                                xs: "0.85rem",
                                sm: "0.95rem"
                            }
                        }
                    }}
                />

                {/* CHILDREN LIST */}
                <Box
                    sx={{
                        maxHeight: 450,
                        overflowY: "auto",
                        borderRadius: "20px",
                        background:
                            "linear-gradient(145deg, #ffffff, #fff8ef)",
                        border: `1px solid ${COLORS.border}`,
                        boxShadow:
                            "0 10px 30px rgba(0,0,0,0.06)",
                        p: 1
                    }}
                >
                    {filteredChildren.length > 0 ? (
                        filteredChildren.map(
                            (child, index) => (
                                <React.Fragment
                                    key={child.id}
                                >
                                    <Box
                                        onClick={() =>
                                            selectChild(
                                                child
                                            )
                                        }
                                        sx={{
                                            display: "flex",
                                            alignItems:
                                                "center",
                                            gap: 1.5,
                                            p: {
                                                xs: 1.3,
                                                sm: 1.8
                                            },
                                            borderRadius:
                                                "15px",
                                            cursor: "pointer",
                                            transition:
                                                "all 0.25s ease",
                                            "&:hover": {
                                                background:
                                                    COLORS.lightCamel,
                                                transform:
                                                    "translateX(4px)"
                                            }
                                        }}
                                    >
                                       <Avatar
                                          src={child.student_admission_image || defaultAvatar}
                                          alt={child.full_name}
                                          imgProps={{
                                            onError: (event) => {
                                              event.target.onerror = null;
                                              event.target.src = defaultAvatar;
                                            }
                                          }}
                                          sx={{
                                            width: { xs: 45, sm: 52 },
                                            height: { xs: 45, sm: 52 },
                                            border: `3px solid ${COLORS.orange}`,
                                            flexShrink: 0
                                          }}
                                        />

                                        <Box
                                            sx={{
                                                minWidth: 0,
                                                flex: 1
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontWeight: 900,
                                                    color: COLORS.black,
                                                    fontSize: {
                                                        xs: "0.85rem",
                                                        sm: "0.95rem"
                                                    },
                                                    overflow:
                                                        "hidden",
                                                    textOverflow:
                                                        "ellipsis",
                                                    whiteSpace:
                                                        "nowrap"
                                                }}
                                            >
                                                {
                                                    child.full_name
                                                }
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: COLORS.gray,
                                                    fontSize: {
                                                        xs: "0.7rem",
                                                        sm: "0.8rem"
                                                    },
                                                    mt: 0.3
                                                }}
                                            >
                                                {child.grade_class_name ||
                                                    "Student"}
                                            </Typography>
                                        </Box>

                                        <ArrowForward
                                            sx={{
                                                color: COLORS.orange,
                                                flexShrink: 0
                                            }}
                                        />
                                    </Box>

                                    {index <
                                        filteredChildren.length -
                                            1 && (
                                        <Divider
                                            sx={{
                                                mx: 1
                                            }}
                                        />
                                    )}
                                </React.Fragment>
                            )
                        )
                    ) : (
                        <Box
                            sx={{
                                py: 6,
                                textAlign: "center"
                            }}
                        >
                            <School
                                sx={{
                                    fontSize: 45,
                                    color: COLORS.camel,
                                    mb: 1
                                }}
                            />

                            <Typography
                                sx={{
                                    color: COLORS.gray,
                                    fontWeight: 700
                                }}
                            >
                                No matching children found.
                            </Typography>
                        </Box>
                    )}
                </Box>
            </>
        ) : (
            <>
                {/* BACK BUTTON */}
                <Button
                    startIcon={<BackIcon />}
                    onClick={() => {
                        setSelectedChild(null);
                        setShowGrades(false);
                        setShowPayments(false);
                    }}
                    sx={{
                        mb: 2.5,
                        color: COLORS.black,
                        fontWeight: 800,
                        borderRadius: "12px",
                        px: 2,
                        "&:hover": {
                            backgroundColor:
                                COLORS.lightCamel
                        }
                    }}
                >
                    Back to Children
                </Button>

                {/* {!showGrades ? ( */}
                {!showGrades && !showPayments ? (
                    <Box
                        sx={{
                            width: "100%",
                            borderRadius: {
                                xs: "20px",
                                md: "28px"
                            },
                            overflow: "hidden",
                            background:
                                "linear-gradient(135deg, #111111 0%, #292929 42%, #e87519 100%)",
                            boxShadow:
                                "0 18px 45px rgba(0,0,0,0.18)"
                        }}
                    >
                        {/* PROFILE HEADER */}
                        <Box
                            sx={{
                                p: {
                                    xs: 2,
                                    sm: 3,
                                    md: 4
                                },
                                display: "flex",
                                flexDirection: {
                                    xs: "column",
                                    sm: "row"
                                },
                                alignItems: "center",
                                gap: {
                                    xs: 2,
                                    sm: 3
                                },
                                textAlign: {
                                    xs: "center",
                                    sm: "left"
                                }
                            }}
                        >
                            <Avatar
                                alt={
                                    selectedChild.full_name
                                }
                                src={
                                    selectedChild.student_admission_image  ||
                                    defaultAvatar
                                }
                                imgProps={{
                                    onError: (
                                        event
                                    ) => {
                                        event.target.onerror =
                                            null;
                                        event.target.src =
                                            defaultAvatar;
                                    }
                                }}
                                sx={{
                                    width: {
                                        xs: 110,
                                        sm: 135,
                                        md: 155
                                    },
                                    height: {
                                        xs: 110,
                                        sm: 135,
                                        md: 155
                                    },
                                    border: `5px solid ${COLORS.camel}`,
                                    boxShadow:
                                        "0 10px 25px rgba(0,0,0,0.35)",
                                    flexShrink: 0
                                }}
                            />

                            <Box
                                sx={{
                                    minWidth: 0,
                                    flex: 1
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: COLORS.white,
                                        fontWeight: 900,
                                        fontSize: {
                                            xs: "1.3rem",
                                            sm: "1.8rem",
                                            md: "2.2rem"
                                        },
                                        lineHeight: 1.2,
                                        wordBreak:
                                            "break-word"
                                    }}
                                >
                                    {
                                        selectedChild.full_name
                                    }
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#f7d7b5",
                                        mt: 0.8,
                                        fontSize: {
                                            xs: "0.8rem",
                                            sm: "0.95rem"
                                        }
                                    }}
                                >
                                    Student Profile
                                </Typography>

                                <Button
                                    variant="contained"
                                    onClick={() =>
                                        setShowGrades(
                                            true
                                        )
                                    }
                                    sx={{
                                        mt: 2,
                                        borderRadius:
                                            "12px",
                                        px: 2.5,
                                        fontWeight: 900,
                                        color: COLORS.black,
                                        background:
                                            "linear-gradient(135deg, #f4c27a, #ffffff)",
                                        "&:hover": {
                                            background:
                                                "linear-gradient(135deg, #ffffff, #f4c27a)"
                                        }
                                    }}
                                >
                                    View Grades
                                </Button>
                                <Button
                                variant="contained"
                                onClick={() =>
                                    setShowPayments(true)
                                }
                                sx={{
                                    mt: 2,
                                    ml: 2,
                                    borderRadius: "12px",
                                    px: 2.5,
                                    fontWeight: 900,
                                    color: COLORS.white,
                                    background:
                                        "linear-gradient(135deg,#1565c0,#42a5f5)",
                                    "&:hover": {
                                        background:
                                            "linear-gradient(135deg,#0d47a1,#1976d2)"
                                    }
                                }}
                            >
                                Payment Transactions
                            </Button>
                            </Box>
                        </Box>

                        {/* PROFILE CONTENT */}
                        <Box
                            sx={{
                                background:
                                    "linear-gradient(135deg, #fffaf3 0%, #ffffff 55%, #f7eadb 100%)",
                                p: {
                                    xs: 1.5,
                                    sm: 2.5,
                                    md: 4
                                }
                            }}
                        >
                            {/* BASIC INFORMATION */}
                            <Box
                                sx={{
                                    p: {
                                        xs: 1.8,
                                        sm: 2.5
                                    },
                                    mb: 3,
                                    borderRadius:
                                        "20px",
                                    background:
                                        COLORS.white,
                                    border: `1px solid ${COLORS.border}`,
                                    boxShadow:
                                        "0 8px 25px rgba(0,0,0,0.06)"
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontWeight: 900,
                                        color: COLORS.black,
                                        mb: 1
                                    }}
                                >
                                    Student Information
                                </Typography>

                                <InfoRow
                                    label="Grade Class"
                                    value={
                                        selectedChild.grade_class_name
                                    }
                                />

                                <InfoRow
                                    label="Division"
                                    value={
                                        selectedChild.division_assigned_name
                                    }
                                />
                            </Box>

                            {/* SUMMARY CARDS */}
                            <Box
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 2,
                                    mb: 3
                                }}
                            >
                                <SectionCard
                                    title="Attendance Summary"
                                    icon={
                                        <EventAvailable />
                                    }
                                >
                                    <StatGrid
                                        items={[
                                            {
                                                label: "Present",
                                                value:
                                                    selectedChild.total_present ??
                                                    0,
                                                color:
                                                    COLORS.green
                                            },
                                            {
                                                label: "Absent",
                                                value:
                                                    selectedChild.total_absent ??
                                                    0,
                                                color:
                                                    COLORS.red
                                            },
                                            {
                                                label: "Late",
                                                value:
                                                    selectedChild.total_late ??
                                                    0,
                                                color:
                                                    COLORS.orange
                                            }
                                        ]}
                                    />
                                </SectionCard>

                                <SectionCard
                                    title="Fees"
                                    icon={
                                        <AccountBalanceWallet />
                                    }
                                >
                                    <StatGrid
                                        items={[
                                            {
                                                label: "Total Fee",
                                                value:
                                                    formatCurrency(
                                                        selectedChild.total_fee
                                                    ),
                                                color:
                                                    COLORS.black
                                            },
                                            {
                                                label: "Amount Paid",
                                                value:
                                                    formatCurrency(
                                                        selectedChild.amount_paid
                                                    ),
                                                color:
                                                    COLORS.green
                                            },
                                            {
                                                label: "Balance",
                                                value:
                                                    formatCurrency(
                                                        selectedChild.balance_fee
                                                    ),
                                                color:
                                                    COLORS.red
                                            }
                                        ]}
                                    />
                                </SectionCard>
                            </Box>

                            {/* COMPLAINTS */}
                            <SectionCard
                                title="Complaints"
                                icon={
                                    <ReportProblem />
                                }
                                fullWidth
                            >
                                {selectedChild.complaints
                                    ?.length > 0 ? (
                                    <>
                                        <Box
                                            sx={{
                                                display:
                                                    "flex",
                                                alignItems:
                                                    "center",
                                                justifyContent:
                                                    "space-between",
                                                gap: 1,
                                                p: 1,
                                                borderRadius:
                                                    "14px",
                                                background:
                                                    COLORS.lightCamel
                                            }}
                                        >
                                            <IconButton
                                                onClick={() =>
                                                    handlePrev(
                                                        selectedChild
                                                    )
                                                }
                                                disabled={
                                                    currentComplaintIndex(
                                                        selectedChild
                                                    ) === 0
                                                }
                                                sx={{
                                                    color:
                                                        COLORS.black
                                                }}
                                            >
                                                <ArrowBackIosNew fontSize="small" />
                                            </IconButton>

                                            <Typography
                                                sx={{
                                                    color:
                                                        COLORS.black,
                                                    fontWeight:
                                                        800,
                                                    fontSize:
                                                        "0.8rem",
                                                    textAlign:
                                                        "center"
                                                }}
                                            >
                                                {currentComplaintIndex(
                                                    selectedChild
                                                ) +
                                                    1}{" "}
                                                of{" "}
                                                {
                                                    selectedChild
                                                        .complaints
                                                        .length
                                                }
                                            </Typography>

                                            <IconButton
                                                onClick={() =>
                                                    handleNext(
                                                        selectedChild,
                                                        selectedChild
                                                            .complaints
                                                            .length
                                                    )
                                                }
                                                disabled={
                                                    currentComplaintIndex(
                                                        selectedChild
                                                    ) ===
                                                    selectedChild
                                                        .complaints
                                                        .length -
                                                        1
                                                }
                                                sx={{
                                                    color:
                                                        COLORS.black
                                                }}
                                            >
                                                <ArrowForward fontSize="small" />
                                            </IconButton>
                                        </Box>

                                        <Box
                                            sx={{
                                                maxHeight: 260,
                                                overflowY:
                                                    "auto",
                                                display:
                                                    "flex",
                                                flexDirection:
                                                    "column",
                                                gap: 1.5
                                            }}
                                        >
                                            {selectedChild.complaints.map(
                                                (
                                                    complaint,
                                                    index
                                                ) => {
                                                    const isActive =
                                                        index ===
                                                        currentComplaintIndex(
                                                            selectedChild
                                                        );

                                                    return (
                                                        <Box
                                                            key={
                                                                complaint.id
                                                            }
                                                            sx={{
                                                                p: {
                                                                    xs: 1.5,
                                                                    sm: 2
                                                                },
                                                                borderRadius:
                                                                    "15px",
                                                                background:
                                                                    isActive
                                                                        ? "linear-gradient(135deg, #fff1df, #ffffff)"
                                                                        : COLORS.white,
                                                                border: `1px solid ${
                                                                    isActive
                                                                        ? COLORS.orange
                                                                        : COLORS.border
                                                                }`
                                                            }}
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    color:
                                                                        COLORS.black,
                                                                    fontWeight:
                                                                        900,
                                                                    fontSize:
                                                                        {
                                                                            xs: "0.85rem",
                                                                            sm: "0.95rem"
                                                                        }
                                                                }}
                                                            >
                                                                {
                                                                    complaint.title
                                                                }
                                                            </Typography>

                                                            {isActive && (
                                                                <Typography
                                                                    sx={{
                                                                        mt: 1,
                                                                        color:
                                                                            "#4b5563",
                                                                        fontSize:
                                                                            {
                                                                                xs: "0.78rem",
                                                                                sm: "0.88rem"
                                                                            },
                                                                        lineHeight: 1.6,
                                                                        whiteSpace:
                                                                            "pre-wrap"
                                                                    }}
                                                                >
                                                                    {
                                                                        complaint.description
                                                                    }
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    );
                                                }
                                            )}
                                        </Box>
                                    </>
                                ) : (
                                    <Typography
                                        sx={{
                                            color: COLORS.gray,
                                            fontSize:
                                                "0.9rem"
                                        }}
                                    >
                                        No complaints recorded.
                                    </Typography>
                                )}
                            </SectionCard>
                        </Box>
                    </Box>
) : showGrades ? (

    <ParentsStudentGrades

        selectedChild={selectedChild}

        onBack={() =>
            setShowGrades(false)
        }

    />

) : (

    <TransActionPerStudent

        selectedChild={selectedChild}

        onBack={() =>
            setShowPayments(false)
        }

    />

)}
            </>
        )}
    </Box>
);


};

export default LinkStudents;


